
const jsgl = {
  data() {
    return {
      options: [
        { title: '提交站点申请', desc: '', name: '' },
        { title: '等待审核通过', desc: '', name: '' },
        { title: '等待画线', desc: '', name: '' },
        { title: '等待安装', desc: '', name: '' },
        { title: '站点完成', desc: '', name: '' }
      ],
      active: 1,
      optionsCopy: [
        { title: '提交站点申请', desc: '', name: '' },
        { title: '等待审核通过', desc: '', name: '' },
        { title: '等待画线', desc: '', name: '' },
        { title: '等待安装', desc: '', name: '' },
        { title: '站点完成', desc: '', name: '' }
      ]
    }
  },
  methods: {
    zdsq_sh_return() {
      console.log('站点管理 - 撤回')
      // 增加逻辑待画线的站点，撤回的时候提示“请删除站点管理中相关站点”
      const vm = this
      const data = {
        userId: vm.user.id,
        id: vm.rowData.id
      }
      const params = {
        selfAreaId: vm.selfAreaId
      }
      // 检验
      for (const btn of this.miTableBtn.children) {
        if (this.$refs[btn.id] && this.$refs[btn.id][0]) {
          const vmCom = this.$refs[btn.id][0]
          const v = vmCom.getValue()
          const vmComParams = vmCom.params
          if (vmComParams.require && !v) {
            return vm.$message.error(vmComParams.errText)
          } else {
            data.reply = v[vmComParams.key]
          }
        }
      }
      vm.postApiPre(data, params, vm.miTableBtn.api)
        .then(res => {
          // 刷新页面
          if (res && res.code === 200) {
            vm.$message.success('站点申请撤回成功！')
            if (vm.miTableBtn.id === '1000-tb-2') {
              vm.$message.success('请删除站点管理中的虚拟站点！')
            }
            vm.onCloseDialog()
            const currTab = vm.configJs.find(item => item.active)
            vm.refreshPage(currTab)
          } else {
            vm.$message.warning(res && res.message)
          }
        })
        .catch(err => {
          console.log('the zdsq_sh_return has problem: ', err)
        })
    },
    zdsq_sh_pass() {
      console.log('zdsq_sh_pass')
      const vm = this
      const data = {
        id: vm.rowData.id,
        userId: vm.user.id
      }
      data.id = vm.rowData.id
      const params = {
        selfAreaId: vm.selfAreaId
      }
      vm.postApiPre(data, params, vm.sureBtnClickContent.fnApi)
        .then(res => {
          if (res && res.code === 200) {
            vm.$message.success('站点申请审核通过成功！')
          } else {
            vm.$message.warning(res && res.message)
          }
          // 二层重置
          vm.$refs['w-two-dialog'].onCloseDialog()
          // 一层重置
          vm.onCloseDialog()
          // 刷新页面
          const currTab = vm.configJs.find(item => item.active)
          vm.refreshPage(currTab)
        })
    },
    zdsq_sh_tow_fail_sure() {
      const vm = this
      let checked = false
      if (vm.sureBtnClickContent && vm.sureBtnClickContent.children) {
        // 检验
        checked = vm.sureBtnClickContent.children.some(item => item.require && !item.value)
        if (checked) {
          const curr = vm.sureBtnClickContent.children.find(item => item.require && !item.value)
          vm.$message.error(curr.errText)
          return null
        }
        // 取值
        const data = {}
        vm.sureBtnClickContent.children.forEach(item => {
          data[item.key] = item.value
        })
        console.log('data', data)
        data.id = vm.rowData.id
        data.userId = vm.user.id
        const params = {
          selfAreaId: vm.selfAreaId
        }
        vm.postApiPre(data, params, vm.sureBtnClickContent.api)
          .then(res => {
            if (res && res.code === 200) {
              vm.$message.success('站点申请审核拒绝成功！')
            } else {
              vm.$message.warning(res && res.message)
            }
            // 二层重置
            vm.onTwoCloseDialog()
            // 一层重置
            vm.onCloseDialog()
            // 刷新页面
            const currTab = vm.configJs.find(item => item.active)
            vm.refreshPage(currTab)
          })
      }
      console.log('zdsq_sh_tow_fail_sure')
    },
    zdsq_sh_tow_fail_fail() {
      console.log('zdsq_sh_tow_fail_fail')
      if (this.sureBtnClickContent && this.sureBtnClickContent.children) {
        this.sureBtnClickContent.children.forEach(item => {
          // 数据清理
          item.value = ''
          // 组件清理
          if (this.$refs && this.$refs[item.id] && this.$refs[item.id][0].reset) {
            this.$refs[item.id][0].reset()
          }
        })
        this.sureBtnClickContent = undefined
        this.$refs['w-two-dialog'].onCloseDialog()
      }
    },
    zdsq_sh_reject() {
      console.log('zdsq_sh_reject')
      // 二层重置
      this.$refs['w-two-dialog'].onCloseDialog()
    },
    // 点击查看 数据转换
    zdsq_sh_translate_data() {
      console.log('zdsq_sh_translate_data')
      this.options = JSON.parse(JSON.stringify(this.optionsCopy))
      this.active = 1
      if (this.rowData && this.rowData.applyPictures) {
        this.rowData.showPictures = this.rowData.applyPictures.split(',')
      } else if (this.rowData && this.rowData.pictures) {
        this.rowData.showPictures = this.rowData.pictures.split(',')
      }
      const current = this.rowData.current
      if (!current['2'] && current['-1']) {
        current['2'] = current['-1']
      } else if (current['2'] && !current['-1']) {
      } else if (current['2'] && current['-1']) {
        const updateTime2 = new Date(current['2'].updateTime).getTime()
        const updateTime1 = new Date(current['-1'].updateTime).getTime()
        if (updateTime2 < updateTime1) {
          current['2'] = current['-1']
        }
      }
      // 1-待审核，2-待画线，3-待安装，4-审核拒绝，5-不可画线，6-不可安装
      let status = '待审核'
      let huaxianPictures = ''
      let anzhuangPictures = ''
      this.options[0].title = '提交站点申请'
      this.options[0].desc = this.rowData.createTime
      this.options[0].name = this.rowData.miUsersName
      // 2=审核组
      if (current['2']) {
        const curr = current['2']
        // 审核意见 0, 1=同意 3=拒绝
        if (Number(curr.applyStatus) === 1) {
          this.options[1].title = '已审核通过'
          this.options[1].desc = curr.createTime
          this.options[1].name = curr.checkUserName
          this.active = 2
        } else {
          this.options[1].title = '审核已拒绝'
          this.options[1].desc = curr.createTime
          this.options[1].name = curr.checkUserName
          this.options.splice(2) // 原属组截取
          this.active = 2
          status = '审核已拒绝'
        }
        // 3=划线组
        if (current['3']) {
          const curr = current['3']
          // 审核意见 0, 1=同意 3=拒绝
          if (Number(curr.applyStatus) === 1) {
            this.options[2].title = '已画线'
            this.options[2].desc = curr.createTime
            this.options[2].name = curr.drawUserName
            this.active = 3
          } else {
            this.options[2].title = '不可画线'
            this.options[2].desc = curr.createTime
            this.options[2].name = curr.drawUserName
            this.options.splice(3) // 原属组截取
            this.active = 3
            status = '不可画线'
          }
          // 画线组图片
          if (curr.pictures) {
            huaxianPictures = curr.pictures
          }
          // 4=安装组
          if (current['4']) {
            const curr = current['4']
            // 审核意见 0, 1=同意 3=拒绝
            if (Number(curr.applyStatus) === 1) {
              this.options[3].title = '已安装'
              this.options[3].desc = curr.createTime
              this.options[3].name = curr.installUserName
              this.options[4].title = '站点完成'
              this.options[4].desc = curr.createTime
              this.active = 5
              status = '站点完成'
            } else {
              this.options[3].title = '设备不可安装'
              this.options[3].desc = curr.createTime
              this.options[3].name = curr.installUserName
              this.options.splice(4) // 原属组截取
              this.active = 4
              status = '设备不可安装'
            }
            // 安装图片
            if (curr.pictures) {
              anzhuangPictures = curr.pictures
            }
          } else {
            // 已画线 未安装
            this.active = 3
            if (Number(current['3'].applyStatus) === 1) {
              status = '待安装'
            }
          }
        } else {
          // 已审核 未画线
          this.active = 2
          if (Number(current['2'].applyStatus) === 1) {
            status = '待画线'
          }
        }
      } else {
        // 已申请 未审核
        this.active = 1
        status = '待审核'
      }
      // 图片
      this.$set(this.rowData, 'huaxianPictures', huaxianPictures)
      this.$set(this.rowData, 'anzhuangPictures', anzhuangPictures)
      // 自定义状态
      this.$set(this.rowData, 'selfStatus', status)
      // 步骤
      this.rowData.active = this.active
      this.rowData.options = this.options
      // 拒绝/通过
      const hasRejectAndPass = Number(this.rowData.auditCurrent) === 2 && Number(this.rowData.applyStatus) === 0
      this.$set(this.rowData, 'hasRejectAndPass', hasRejectAndPass)
    }
  }
}

export default jsgl
